import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import { _ } from '../../functions/translator.js';
import LegendInfo from './legendInfo.js';
import { ColorAttributes, 
        ToggleActions, 
        delayedLegendInfo, 
        progressLegendInfo, 
        statusLegendInfo,
        PaidLegendInfo,
        HistoricalObservationsLegendInfo,
        DatesLegendInfo } from '../../constants/constants.js';
import { getAvailableCardCategoryIds, getStartDateLegendInfo } from '../../functions/getter.js';
import { toggleSwitch } from '../../actions/index.js';
import InfoTooltip from '../infoTooltip/infoTooltip.js';

class Legend extends React.Component {

    getCardCategoriesInfo = () => {
        const cardCategoryIds = getAvailableCardCategoryIds(
            this.props.cardCategoriesData,
            this.props.stageIds,
            this.props.levelIds,
            this.props.matches.levels_card_categories
        )
        const info = {};
        for (const cardCategoryId of cardCategoryIds) {
            const cardCategoryData = this.props.cardCategoriesData[cardCategoryId];
            info[cardCategoryId] = {
                color: cardCategoryData.attributes.color,
                description: cardCategoryData.attributes.name
            };
        }
        return info;
    }

    getLegendInfo = () => {
        switch (this.props.paint) {
            case ColorAttributes.STATUS:
                return statusLegendInfo;
            case ColorAttributes.PROGRESS:
                return progressLegendInfo;
            case ColorAttributes.DELAYED:
                return delayedLegendInfo;
            case ColorAttributes.PAID_PHYSICAL_PROGRESS:
                return PaidLegendInfo;
            case ColorAttributes.HISTORICAL_OBSERVATIONS:
                return HistoricalObservationsLegendInfo;
            case ColorAttributes.DATES:
                return getStartDateLegendInfo(this.props.day);
            case ColorAttributes.CARD_CATEGORY:
                return this.getCardCategoriesInfo();
            default:
                return {};
        }
    }

    handleCloseChange = () => {
        this.props.toggleSwitch(ToggleActions.LEGEND, false);
    }

    render() {
        const render = this.props.legend && !this.props.popUpMenu.show && !this.props.metrics && !this.props.signaturesFilter;
        const legendInfo = this.getLegendInfo();
        return(
            <div>
                <Slide in={render} direction='left'>
                    <div className={this.props.timeline || this.props.graph ? "legend-card-layout legend-left card-color" : "legend-card-layout card-color"}>
                        {this.props.paint === ColorAttributes.DATES && <InfoTooltip class={'float-left'} placement={'left'} message={'color by start date messaje'}/>}
                        <p className='text mt-0'>{ _('Leyenda') }
                            <CloseIcon className='float-right cursor-pointer' onClick={this.handleCloseChange}/>
                        </p>
                        <div className="card-subcolor">
                            <LegendInfo legendInfo={legendInfo}/>
                        </div>
                    </div>
                </Slide>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        paint              : state.paint,
        legend             : state.switches.legend,
        timeline           : state.switches.timeline,
        metrics            : state.switches.metrics,
        signaturesFilter     : state.switches.signaturesFilter,
        popUpMenu          : state.popUpMenu,
        graph              : state.switches.graph,
        stageIds           : state.filters.stageIds,
        levelIds           : state.filters.levelIds,
        matches            : state.matches,
        cardCategoriesData : state.projectData.card_categories,
        timelineSelect     : state.filters.timelineSelect,
        day                : state.day,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch: toggleSwitch
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Legend);